import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchPoints(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          //.get('/apps/user/users', { params: queryParams })
          .get(`/api/v1/PointOfInterest/search?Search=${queryParams.q}&Page=${queryParams.page}&PerPage=${queryParams.perPage}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchPoint(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          //.get(`/apps/user/users/${id}`)
          .get(`/api/v1/PointOfInterest?id=${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addPoint(ctx, pointData) {
      return new Promise((resolve, reject) => {
        
        let point = pointData.pointData
        axios
          //.post('/apps/customer/customers', { customer: customerData })
          .post('/api/v1/PointOfInterest',  point)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updatePoint(ctx, pointData) {
      return new Promise((resolve, reject) => {
        
        let point = pointData.pointData
        axios
          //.post('/apps/customer/customers', { customer: customerData })
          .put('/api/v1/PointOfInterest',  point)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deletePoint(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/api/v1/PointOfInterest?Id=${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
  },
    fetchCustomers(ctx, queryParams) {

      return new Promise((resolve, reject) => {
          
          axios
              //.get('/apps/asset/assets', { params: queryParams })
              .get(`/api/v1/Customer/search?Search=${queryParams.q}&Page=1&PerPage=5`)
              //.get(`/api/v1/Asset/search?Page=${queryParams.page}&PerPage=${queryParams.perPage}`)
              .then(response => resolve(response))
              .catch(error => reject(error))
      })
  },
  fetchCustomer(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          //.get(`/apps/user/users/${id}`)
          .get(`/api/v1/Customer?id=${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
